import React, { Component } from 'react';
import { connect } from 'react-redux';
import RGL, { WidthProvider } from "react-grid-layout";
import Paper from '@material-ui/core/Paper';
import TopKontoBarn from '../../Inputs/TopKontoBarn'
import VunnenAffar from '../../Inputs/VunnenAffar'
import TableKontoBarn from '../../Inputs/TableKontoBarn'
import SkapadProspekt from '../../Inputs/SkapadProspekt'
import NyaOrder from '../../Inputs/NyaOrder'
import BokadeMoten from '../../Inputs/BokadeMoten'
import LastVunnen from '../../Inputs/LastVunnen'
import LastBokade from '../../Inputs/LastBokade'
import DashBoardDatumFilter from '../../Inputs/DashBoardDatumFilter'
import CustomScrollbars from 'util/CustomScrollbars';

function mapStateToProps({auth,accountsData}) {
    const authUser = auth.authUser
    const Childlista = accountsData.Childlista
    return {
        Childlista,authUser
    };
}

function mapDispatchToProps(dispatch) {
    return {

    };
}
const ReactGridLayout = WidthProvider(RGL);
class ExtraLargeDesktopGrid extends Component {
    
    render() {
        return (
            <ReactGridLayout
            className="layout"
            rowHeight={44}
            style={{  width: "98vw" }}
            >
            <Paper style={{ backgroundColor: '#14484D', color: '#fff', overflow: 'hidden' }} key="1" 
            data-grid={{ x: 0, y: 0, w: 7, h: 5, static: true }}>
                <span className="text">
                  <TopKontoBarn circle={100} Afid={this.props.Afid}/>
                </span>
            </Paper> 
            <Paper style={{ backgroundColor: '#14484D', color: '#fff', overflow: 'hidden' }} key="2" 
            data-grid={{ x: 7, y: 0, w: 5, h: 5, static: true }}>
                <span className="text">
               <TableKontoBarn Afid={this.props.Afid}/>
                </span>
            </Paper> 
            <Paper style={{ backgroundColor: '#14484D', color: '#fff', overflow: 'hidden' }} key="3" 
            data-grid={{ x: 0, y: 5, w: 3, h: 4, static: true }}>
                <span className="text">
               <VunnenAffar size={100}Afid={this.props.Afid} />        
                </span>
            </Paper> 
            <Paper style={{ backgroundColor: '#14484D', color: '#fff', overflow: 'hidden' }} key="4" 
            data-grid={{ x: 3, y: 5, w: 3, h: 4, static: true }}>
                <span className="text">
            {/* */}     <SkapadProspekt size={100} Afid={this.props.Afid}/>                  
                </span>
            </Paper> 
            <Paper style={{ backgroundColor: '#14484D', color: '#fff', overflow: 'hidden' }} key="7" 
            data-grid={{ x: 0, y: 9, w: 3, h: 4, static: true }}>
                  <span className="text">
                  <NyaOrder size={100} Afid={this.props.Afid}/>
                    </span>
            </Paper> 
            <Paper style={{ backgroundColor: '#14484D', color: '#fff', overflow: 'hidden' }} key="8" 
            data-grid={{ x: 3, y: 9, w: 3, h: 4, static: true }}>
                <span className="text">
              <BokadeMoten size={100} Afid={this.props.Afid}/>
                </span>
            </Paper> 

            <Paper style={{ backgroundColor: '#14484D', color: '#fff', overflow: 'hidden' }} key="9" 
            data-grid={{ x: 6, y: 5, w: 3, h: 8, static: true }}>
                <span className="text">
                <LastVunnen Afid={this.props.Afid}/>
                </span>
            </Paper> 
            <Paper style={{ backgroundColor: '#14484D', color: '#fff', overflow: 'hidden' }} key="10" 
            data-grid={{ x: 9, y: 5, w: 3, h: 8, static: true }}>
                <span className="text">
                <LastBokade Afid={this.props.Afid}/>
                </span>
            </Paper> 
            </ReactGridLayout>
        );
    }
}

export default connect(
    mapStateToProps,
)(ExtraLargeDesktopGrid);